"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var store = function store(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'store-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // eslint-disable-next-line max-len
    d: 'M5.0528 4.21738C5.34923 3.6245 5.95519 3.25 6.61804 3.25H13.382C14.0448 3.25 14.6508 3.6245 14.9472 4.21738L16.5623 7.44751C16.5895 7.50202 16.6107 7.5574 16.6262 7.61305C16.7045 7.73542 16.75 7.88092 16.75 8.03704V9.5C16.75 10.2801 16.353 10.9675 15.75 11.3711V15C15.75 15.9665 14.9665 16.75 14 16.75H6C5.0335 16.75 4.25 15.9665 4.25 15V11.3711C3.64701 10.9675 3.25 10.2801 3.25 9.5V8.03704C3.25 7.8809 3.29547 7.73538 3.37388 7.613C3.38933 7.55737 3.41048 7.502 3.43773 7.44751L5.0528 4.21738ZM13.75 8.75H15.25V9.5C15.25 9.91421 14.9142 10.25 14.5 10.25C14.0858 10.25 13.75 9.91421 13.75 9.5V8.75ZM14.25 11.7363C13.7723 11.6835 13.3397 11.4811 13 11.1771C12.6019 11.5334 12.0763 11.75 11.5 11.75C10.9237 11.75 10.3981 11.5334 10 11.1771C9.60193 11.5334 9.07627 11.75 8.5 11.75C7.92373 11.75 7.39807 11.5334 7 11.1771C6.66031 11.4811 6.22769 11.6835 5.75 11.7363V15C5.75 15.1381 5.86193 15.25 6 15.25H9V12.75C9 12.6119 9.11193 12.5 9.25 12.5H10.75C10.8881 12.5 11 12.6119 11 12.75V15.25H14C14.1381 15.25 14.25 15.1381 14.25 15V11.7363ZM9.25 8.75V9.5C9.25 9.91421 8.91421 10.25 8.5 10.25C8.08579 10.25 7.75 9.91421 7.75 9.5V8.75H9.25ZM5.21353 7.25L6.39444 4.8882C6.43678 4.8035 6.52335 4.75 6.61804 4.75H13.382C13.4767 4.75 13.5632 4.8035 13.6056 4.8882L14.7865 7.25H5.21353ZM11.5 10.25C11.0858 10.25 10.75 9.91421 10.75 9.5V8.75H12.25V9.5C12.25 9.91421 11.9142 10.25 11.5 10.25ZM6.25 8.75H4.75V9.5C4.75 9.91421 5.08579 10.25 5.5 10.25C5.91421 10.25 6.25 9.91421 6.25 9.5V8.75Z',
    fill: '#4B5563'
  }));
};

exports.store = store;